import React, { Component } from "react";
import ReactEcharts from "echarts-for-react";
import { connect } from 'react-redux';

const style = {
    flex: 1,
    height: "400px",
    width: "100%"
};
class HorizontalBar extends Component {
    getOption = () => {
        const { preguntas, calificaciones, labels } = this.props;

        let series = [];
        let series_labels = [];
        let axis_labels = [];
        
        Object.keys(calificaciones).map(function (key, index) {
            if(key !=0){
                // si labels están presentes, usar la etiqueta completa
                let value = calificaciones[key];
                series.push(value);
                // almacenar la etiqueta que queremos mostrar DENTRO de la barra
                series_labels.push(labels && labels[key] ? labels[key] : (preguntas[key] || ''));
                // para el eje Y dejamos una cadena vacía (ocultaremos labels) pero mantenemos la fila
                axis_labels.push('');
            }
        });

        const options = {
            grid: {
                top: 6,
                left: 18,
                right: 26,
                bottom: 24,
                containLabel: true
            },
            yAxis: {
                type: 'category',
                data: axis_labels,
                axisLabel: { show: false } // ocultar etiquetas a la izquierda
            },
            xAxis: {
                type: 'value',
                min: 0,
                max: 100,
                axisLabel: {
                    formatter: function (value) {
                        return value + '%';
                    }
                }
            },
            visualMap: {
                orient: 'horizontal',
                left: 'center',
                min: 0,
                max: 100,
                text: ['Excelente','Malo'],
                // Map the score column to color
                dimension: 0,
                inRange: {
                    color: ['#FD665F', '#FFCE34', '#65B581',]
                }
            },
            series: [
                {
                    data: series,
                    type: 'bar',
                    showBackground: true,
                    label: {
                        show: true,
                        formatter: (params) => {
                            let val = params.value;
                            if (val > 100) val = 100;
                            const labelText = series_labels[params.dataIndex] || '';
                            return labelText + ' ' + parseFloat(val).toFixed(2) + '%';
                        },
                        position: 'insideLeft'
                    },
                    backgroundStyle: {
                        color: 'rgba(180, 180, 180, 0.2)'
                    }
                }
            ]
        };
        return options;
    }

    render() {
        return (
            <div id="dashexpectativas">
                <ReactEcharts
                    option={this.getOption()}
                    className="grafica"
                    style={style}
                    notMerge={false}
                    lazyUpdate={true}
                />
            </div>
        );
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        enviarmes: (mes) => dispatch({
            type: 'SET_MES', mes: mes
        })
    }
}
const mapStateToProps = state => ({
    loggedstate: state
})
export default connect(mapStateToProps, mapDispatchToProps)(HorizontalBar);